const tagFields = [
  'nonprofit_tag_ids_in',
];

export default (field) => {
  return tagFields.includes(field);
}
